import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Compagnie } from '../../shared/model';
import { DatabaseConnection } from '../../shared/services/database-connection';

@Injectable({
  providedIn: 'root',
})
export class CompagnieService {
  end_url = 'compagnie'

  constructor(private http : HttpClient, private  dbConnection : DatabaseConnection){}

  getAll(){
    return this.http.get<Compagnie[]>(this.dbConnection.remoteApiConnection.value + this.end_url + '/create')
  }

  create(data : FormData){
    return this.http.post<Compagnie>(this.dbConnection.remoteApiConnection.value + this.end_url, data)
  }

  update(data : FormData, id : string){
    return this.http.post<Compagnie>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id, data)
  }

  delete(id : string){
    return this.http.delete(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id)
  }

  changeStatus(id : string){
    return this.http.get<Compagnie>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id + '/edit')
  }
}
